// Generaciones 2011-2016: el plantel ocupa 3 posiciones (7 a 9) en la matrícula.
// Resto de generaciones: 2 posiciones (7 y 8).
export const plantelDeMatricula = (matricula) => {
  const matriculaStr = String(matricula);
  const anio = parseInt(matriculaStr.substring(0, 2), 10);

  if (anio >= 11 && anio <= 16) {
    return parseInt(matriculaStr.substring(7, 10), 10).toString().padStart(2, "0");
  }
  return matriculaStr.substring(7, 9);
};

// El id de plantel en la base de datos va corrido en 2 respecto al plantel oficial
// (id 03 en BD = plantel 01 Tesistán).
export const idBDDesdePlantel = (plantelOficial) =>
  (parseInt(plantelOficial, 10) + 2).toString();

export const plantelOficialDesdeIdBD = (idBD) =>
  String(Number(idBD) - 2).padStart(2, "0");
